import React, { PureComponent } from 'react';
import { trackEvent, getPostShareLink } from '../common/ambient'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import PropTypes from 'prop-types';
import bindAllActions from '../common/bindAllActions';

class PostShareModal extends PureComponent {
  static propTypes = {
    post: PropTypes.object.isRequired,
  };

  state = {
    copying: false
  }

  componentDidMount() {
    const { post } = this.props
    trackEvent('share', 'PostShareModal', post._id)
  }

  _shareUrl() {
    const { post } = this.props
    return getPostShareLink(post._id)
  }

  render() {
    const { post } = this.props
    const { copying } = this.state
    const selectAll = evt => evt.target.select()
    const shareUrl = this._shareUrl()
    const title = 'Check out this post on AmbientWeather.net'

    return (
      <div className="component-post-share-modal">
        <div className="body">
          <div className="share-icons">
            <a href={`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(shareUrl)}`} target="_blank" className="email"></a>
            <a href={`http://www.facebook.com/sharer/sharer.php?u=${shareUrl}`} target="_blank" className="fb"></a>
            <a href={`http://www.twitter.com/intent/tweet?url=${shareUrl}&via=ambientweather`} target="_blank" className="twitter"></a>
            {post.image && (
              <a href={post.image} target="_blank" className="download" download></a>
            )}
          </div>
          <div className="copy">
            <input onFocus={selectAll} type="text" readOnly value={shareUrl} className="form-control" />
            <CopyToClipboard
              text={shareUrl}
              onCopy={() => {
                this.setState({ copying: true })
                setTimeout(() => {
                  this.setState({ copying: false })
                }, 2000)
              }}
            >
              <a className="btn btn-primary btn-long">{copying ? 'Copied!' : 'Copy Link'}</a>
            </CopyToClipboard>
          </div>
        </div>
      </div>
    );
  }
}

export default bindAllActions(PostShareModal)
PostShareModal.displayName = 'PostShareModal'
